import { PlaceType } from "./api";

// Accent color schemes for place cards (cycling through by type)
const accentSchemes = [
  { bg: "bg-accent/30", solid: "bg-accent", border: "border-chart-1", text: "text-accent-foreground" },
  { bg: "bg-chart-2/20", solid: "bg-chart-2", border: "border-chart-2", text: "text-secondary" },
  { bg: "bg-muted/60", solid: "bg-chart-3", border: "border-chart-3", text: "text-accent-foreground" },
] as const;

export type AccentScheme = (typeof accentSchemes)[number];

export function getAccentForType(type: PlaceType, typeOrder: PlaceType[]): AccentScheme {
  const index = typeOrder.indexOf(type);
  return accentSchemes[(index >= 0 ? index : 0) % accentSchemes.length];
}
